export default __webpack_public_path__ + "51451fcaca0c395139db6fd48bb9a1dc.wasm";